module.exports = __webpack_public_path__ + "img/faq-dashboard-status-sp.de9c6f49.jpg";